import React, { useState, useContext, useEffect, useRef, useMemo } from 'react'
import { /*Table,*/ Switch, Radio, Select, Col, Checkbox, Row, Input, Button } from 'antd';
import { TokenVerificationLoggedin, ScreenView, Block_U_Admin } from "../../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../config/config.json";
import { jwtDecode } from "jwt-decode";
import { notifyfailure, notifysuccess, notifycatch } from "../../utils/toast";

const ACTIVATION_OPTIONS = [
    "Activation is possible using a separate tag",
    "Activation is possible at a higher floor price",
    "Otherwise, reach out to me for clarification",
];

const SENSITIVE_BLOCK_IDS = [
    "IAB25-1", "IAB25-2", "IAB25-3", "IAB25-4", "IAB25-5", "IAB25-6", "IAB25-7",
    "IAB26-1", "IAB26-2", "IAB26-3", "IAB26-4",
    "IAB9-9", "IAB8-18", "IAB8-5", "IAB11-4",
];

function CategoryRows({
    node,
    selected,
    setSelected,
    searchTerm = "",
    isDisabled,
    sensitive = {},
    setSensitive,
    attemptedIds = new Set(),
    setSensitiveAttemptedIds,
}) {
    const [open, setOpen] = useState(false);

    const hasChildren = node.children && node.children.length > 0;
    const childIds = node.children?.map(c => c.id) || [];

    const allChildrenSelected = hasChildren && childIds.every(id => selected.has(id));
    const someChildrenSelected = hasChildren && childIds.some(id => selected.has(id)) && !allChildrenSelected;
    const parentChecked = hasChildren ? allChildrenSelected : selected.has(node.id);
    const parentActive = hasChildren ? (allChildrenSelected || someChildrenSelected) : selected.has(node.id);

    // filter visibility (must be before useEffects that use childMatches)
    const parentMatches = node.name.toLowerCase().includes(searchTerm);
    const childMatches = (node.children || []).filter(c =>
        c.name.toLowerCase().includes(searchTerm)
    );

    // Close dropdown when parent is toggled off
    useEffect(() => {
        if (!hasChildren) return;
        if (!parentActive) setOpen(false);
    }, [parentActive, hasChildren]);

    // Auto open when search matches children
    useEffect(() => {
        if (!hasChildren) return;
        if (searchTerm) setOpen(childMatches.length > 0);
    }, [searchTerm, hasChildren, childMatches.length]);

    const toggleParent = () => {
        setSelected(prev => {
            const next = new Set(prev);
            if (hasChildren) {
                if (someChildrenSelected || allChildrenSelected) {
                    childIds.forEach(id => next.delete(id));
                } else {
                    childIds.forEach(id => next.add(id));
                }
            } else {
                if (next.has(node.id)) next.delete(node.id);
                else next.add(node.id);
            }
            return next;
        });
    };

    const toggleChild = (childId) => {
        setSelected(prev => {
            const next = new Set(prev);
            if (next.has(childId)) next.delete(childId);
            else next.add(childId);
            return next;
        });
    };

    const handleSensitiveCheck = (id) => {
        setSensitive(prev => {
            const current = prev[id] || { isChecked: false, selection: "" };
            return {
                ...prev,
                [id]: { isChecked: !current.isChecked, selection: !current.isChecked ? current.selection : "" },
            };
        });
    };

    const handleSensitiveSelect = (id, value) => {
        setSensitive(prev => ({
            ...prev,
            [id]: { ...(prev[id] || { isChecked: true }), selection: value },
        }));
    };

    if (searchTerm && !parentMatches && childMatches.length === 0) return null;

    return (
        <>
            {/* Parent row */}
            <tr className={`${parentActive ? "bottom_padding_cls" : ""} ${someChildrenSelected ? "is-partial" : ""}`}>
                {/* COL 1: parent switch */}
                <td className="cell checkbox-col">
                    <Switch
                        className={someChildrenSelected ? "switch-partial" : ""}
                        disabled={isDisabled}
                        checked={parentChecked}
                        onChange={() => {
                            if (someChildrenSelected || allChildrenSelected || selected.has(node.id)) {
                                setSensitive(prev => {
                                    const next = { ...prev };
                                    delete next[node.id];
                                    childIds.forEach(id => delete next[id]);
                                    return next;
                                });
                                setSensitiveAttemptedIds(prev => {
                                    const next = new Set(prev);
                                    next.delete(node.id);
                                    childIds.forEach(id => next.delete(id));
                                    return next;
                                });
                            }
                            toggleParent();
                        }}
                    />
                </td>

                {/* COL 2: expander + name + sensitive (parent level only) */}
                <td className="cell name-col td_with_select_checkbox">
                    {hasChildren ? (
                        <button type="button" onClick={() => setOpen(o => !o)}>
                            {open
                                ? <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 1.5L6 6.5L11 1.5" stroke="#98A2B3" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                : <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.5 11L6.5 6L1.5 1" stroke="#98A2B3" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            }
                        </button>
                    ) : (
                        <></>
                    )}
                    <span className={`label ${!hasChildren ? "no-children m-0" : ""}`}>
                        {node.name}
                    </span>
                    {parentActive && (
                        <>
                            <div className="d-flex align-items-center">
                                <div className='primary_checkbox vertical_space_cls'>
                                    <Checkbox
                                        id={`checkbox_sensitive_${node.id}`}
                                        name={`checkbox_sensitive_${node.id}`}
                                        checked={sensitive[node.id]?.isChecked || false}
                                        onChange={() => handleSensitiveCheck(node.id)}
                                        disabled={isDisabled}
                                    >
                                        <span className="form_label">Allow under Custom condition</span>
                                    </Checkbox>
                                </div>
                                {sensitive[node.id]?.isChecked && (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', flex: "1" }} className='m_end_1'>
                                        <Select
                                            className="form_select basic no_search"
                                            showSearch={false}
                                            placeholder="Select your custom requirement to allow sensitive category"
                                            value={sensitive[node.id]?.selection || undefined}
                                            onChange={(val) => handleSensitiveSelect(node.id, val)}
                                            disabled={isDisabled}
                                            options={ACTIVATION_OPTIONS.map(opt => ({ label: opt, value: opt }))}
                                        />
                                        {/* {attemptedIds.has(node.id) && !sensitive[node.id]?.selection && (
                                            <span className="error_content">This field is required</span>
                                        )} */}
                                    </div>
                                )}
                            </div>
                            {sensitive[node.id]?.isChecked && (
                                <>
                                    {attemptedIds.has(node.id) && !sensitive[node.id]?.selection && (
                                        <span className="error_content">This field is required</span>
                                    )}
                                </>
                            )}
                        </>
                    )}
                </td>
            </tr>

            {/* Children rows */}
            {open &&
                (node.children || [])
                    .filter(ch => !searchTerm || ch.name.toLowerCase().includes(searchTerm))
                    .map(ch => (
                        <tr key={ch.id} className={selected.has(ch.id) ? "is-selected" : ""}>
                            {/* COL 1: empty — creates indent */}
                            <td className="cell checkbox-col" />
                            {/* COL 2: switch + name */}
                            <td className="cell name-col child">
                                <Switch
                                    disabled={isDisabled}
                                    checked={selected.has(ch.id)}
                                    onChange={() => toggleChild(ch.id)}
                                />
                                <span className="label no-children m-0">{ch.name}</span>
                            </td>
                        </tr>
                    ))
            }
        </>
    );
}


const BrandSafety = () => {

    const loadingContext = useContext(LoadingContext);
    const [/* checkRole */, setCheckRole] = useState("admin")
    // const [initialValues, setInitialValues] = useState(null);
    // const [isDirty, setIsDirty] = useState(false);
    const [initialPubData, setInitialPubData] = useState(null);

    useEffect(() => {
        TokenVerificationLoggedin();
        ScreenView()
        Block_U_Admin()


        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            let checkRole = jwtDecode(token).role;
            setCheckRole(checkRole)


            axios
                .get((configData.SERVER_URL + "ops/getPubDetails?_id="), {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setSelected(new Set(response?.data?.data?.blockCategory) || new Set())
                    setSelectedTrack(new Set(response?.data?.data?.blockCategory) || new Set())
                    setSensitive(response?.data?.data?.bcate_data || {})

                    const apiData = response?.data?.data || {};
                    // setInitialPubData(sanitizePubData(apiData));
                    setInitialPubData(apiData);


                })
                .catch((error) => {
                    notifyfailure("Failed to fetch the publisher details.")
                });

            axios
                .get(configData.SERVER_URL + "user/iabCat", {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    setDATA(response.data.data);
                })
                .catch((error) => { });


        }

        loadingContext.done()
    }, [loadingContext]);


    //----------------------------------------category related code --------------------------------------------------------------------------------
    // const [checkRole, setCheckRole] = useState("admin");
    const [DATA, setDATA] = useState([]);
    const [selected, setSelected] = useState(new Set());
    const [selectedTrack, setSelectedTrack] = useState(new Set());
    const [sensitive, setSensitive] = useState({});
    const [sensitiveAttemptedIds, setSensitiveAttemptedIds] = useState(new Set());
    const [search, setSearch] = useState("");
    const masterRef = useRef(null);
    const hasInitiallySorted = useRef(false);
    const searchTerm = search.trim().toLowerCase();

    // Normalize blockCategory: expand any parent IDs (e.g. "IAB9") to their children.
    // Uses selectedTrack (set only from server) so user toggles don't re-trigger this.
    // Handles race condition: fires when either DATA or server data loads first.
    useEffect(() => {
        if (!DATA || DATA.length === 0) return;
        setSelected(prev => {
            const next = new Set();
            prev.forEach(id => {
                const parent = DATA.find(cat => cat.id === id);
                if (parent && parent.children && parent.children.length > 0) {
                    parent.children.forEach(ch => next.add(ch.id));
                } else {
                    next.add(id);
                }
            });
            return next;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [DATA, selectedTrack]);

    // One-time sort on initial load: selected nodes float to top
    useEffect(() => {
        if (hasInitiallySorted.current) return;
        if (DATA.length === 0 || initialPubData === null) return;
        const sorted = [...DATA].sort((a, b) => {
            const aActive = a.children?.length
                ? a.children.some(c => selected.has(c.id))
                : selected.has(a.id);
            const bActive = b.children?.length
                ? b.children.some(c => selected.has(c.id))
                : selected.has(b.id);
            return (bActive ? 1 : 0) - (aActive ? 1 : 0);
        });
        hasInitiallySorted.current = true;
        setDATA(sorted);
    }, [DATA, selected, initialPubData]);
    const parentIds = useMemo(() => DATA.map(node => node.id), [DATA]);
    const allSelectedAll = parentIds.every(id => selected.has(id));
    const someSelectedAll = !allSelectedAll && parentIds.some(id => selected.has(id));
    const visibleNodes = DATA.filter(node => {
        const parentMatches = node.name.toLowerCase().includes(searchTerm.toLowerCase());
        const childMatches = (node.children || []).some(c =>
            c.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        return !searchTerm || parentMatches || childMatches;
    });

    // eslint-disable-next-line no-unused-vars
    function getSelectedChildrenCount(options, selected) {
        let count = 0;

        function findNodeById(nodes, id) {
            for (const node of nodes) {
                if (node.id === id) return node;
                if (node.children) {
                    const found = findNodeById(node.children, id);
                    if (found) return found;
                }
            }
            return null;
        }

        for (const id of selected) {
            const node = findNodeById(options, id);
            if (node) {
                if (node.children && node.children.length > 0) {
                    // parent selected → add number of children
                    count += node.children.length;
                } else {
                    // child selected → count 1
                    count += 1;
                }
            }
        }

        return count;
    }

    useEffect(() => {
        if (masterRef.current) {
            masterRef.current.indeterminate = someSelectedAll;
        }
    }, [someSelectedAll]);


    // eslint-disable-next-line no-unused-vars
    const handleMaster = () => {
        setSelected(prev => {
            const next = new Set();

            if (allSelectedAll) {
                // uncheck all
                return next;
            } else {
                // select only parent IDs (not children individually)
                DATA.forEach(node => {
                    next.add(node.id);
                });
            }

            return next;
        });
    };


    // "Block all sensitive categories" checkbox
    const blockAllChecked = SENSITIVE_BLOCK_IDS.every(id => selected.has(id));
    const handleBlockAll = () => {
        setSelected(prev => {
            const next = new Set(prev);
            if (blockAllChecked) {
                SENSITIVE_BLOCK_IDS.forEach(id => next.delete(id));
            } else {
                SENSITIVE_BLOCK_IDS.forEach(id => next.add(id));
            }
            return next;
        });
    };

    //---------------------------------------------------------------------------------------------



    const [tab] = useState("iab")
    const [buttonValue, setButtonValue] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);

    const objectToFormData = (obj) => {
        const formData = new FormData();

        Object.entries(obj).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                formData.append(key, JSON.stringify(value));
            } else if (value !== undefined && value !== null) {
                formData.append(key, value);
            }
        });

        return formData;
    };

    const buildFinalPayload = () => {
        if (!initialPubData) return null;

        return {
            ...initialPubData, // ✅ ALL keys preserved

            // 🔥formatted keys
            im: JSON.stringify(initialPubData.im),
            defineYourself: JSON.stringify(initialPubData.defineYourself),
            inventory_type_select: JSON.stringify(initialPubData.inventory_type_select),
            ad_format_monetise: JSON.stringify(initialPubData.ad_format_monetise),
            ad_format_monetise_other: JSON.stringify(initialPubData.ad_format_monetise_other),
            integration_type: JSON.stringify(initialPubData.integration_type),
            ortb_type: JSON.stringify(initialPubData.ortb_type),
            vast_type: JSON.stringify(initialPubData.vast_type),
            integration_protocol_rich_media_creative: JSON.stringify(initialPubData.integration_protocol_rich_media_creative),
            // blockCategory: JSON.stringify(initialPubData.blockCategory),

            inventoryWebsiteData: initialPubData.inventory_type_select.includes("Website") ? JSON.stringify(initialPubData.inventoryWebsiteData) : [],
            inventoryMobileData: initialPubData.inventory_type_select.includes("Mobile App (Android / iOS)") ? JSON.stringify(initialPubData.inventoryMobileData) : [],
            inventoryCtvData: initialPubData.inventory_type_select.includes("CTV / FAST Apps") ? JSON.stringify(initialPubData.inventoryCtvData) : [],

            //keys to replace / update
            blockCategory: JSON.stringify([...selected]),
            bcate_data: JSON.stringify(
                Object.fromEntries(Object.entries(sensitive).filter(([, v]) => v.isChecked))
            ),
        };
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        // errorDetect()

        // let formData = new FormData();
        // formData.append('blockCategory', JSON.stringify([...selected]));
        const checkedIds = Object.entries(sensitive)
            .filter(([, v]) => v.isChecked)
            .map(([id]) => id);
        setSensitiveAttemptedIds(new Set(checkedIds));
        const hasSensitiveValidationError = checkedIds.some(id => !sensitive[id]?.selection);
        if (hasSensitiveValidationError) {
            notifyfailure("Please select custom requirements for the checked sensitive categories.");
            return;
        }

        const finalPayload = buildFinalPayload();
        if (!finalPayload) return;

        const formData = objectToFormData(finalPayload);

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {

            setButtonValue(true);
            let token = Cookies.get("token_xapads_ssp");
            axios
                .put(`${configData.SERVER_URL}ops/editPub`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "x-access-token": token,
                    }
                }
                )
                .then((response) => {

                    notifysuccess(response.data.message);
                    setTimeout(() => {
                        window.location.reload()
                    }, 1500)

                })
                .catch((error) => {
                    if (error?.response) {
                        if (error.response.data.message?.length !== 0) {
                            notifyfailure(error.response.data.message);
                        }
                    } else {
                        notifycatch();
                    }
                    setButtonValue(false);
                });

        }


    };

    return (
        <div className="new_table_select_row_design_cls container_box--wrapper pt_header">
            <div className="container_box--wrapper--title d_flex justify-content-between">
                <h1 className="heading fw_600"> Brand Safety </h1>
                {/* <button className='btn btn_primary w_fit_content md'>
                    <span>

                        Save
                    </span>
                </button> */}
            </div>
            <div className="d_flex justify_content_between w_100 mb_10">
                <div className="radios_btns --radios_btns_new">
                    <Radio.Group
                        value={tab}
                        className='radio_btn--group mb-0'>
                        <Radio.Button value="iab">IAB Category Blocking</Radio.Button>
                        <Radio.Button value="basicsettings" onClick={() => { window.location.replace("/basicSettings") }} >Basic Settings</Radio.Button>
                    </Radio.Group>
                </div>

            </div>
            <div className="container_box--form-container bg-transparent border-0 p-0">
                <div className="container_box--width">
                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Sensitive categories you would like us to block on your supply.</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container mb_0">
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group mb-0">
                                            <div className="block-category block_category_adjustment --table_width_css">
                                                <div className="form_content_block--group mb-0">
                                                    <div className="d_flex justify_content_between mb_10 align-items-center">
                                                        <Input
                                                            type='text'
                                                            className='form_control basic md search_input w_table_search'
                                                            placeholder="Search"
                                                            value={search}
                                                            onChange={e => setSearch(e.target.value)}
                                                        />
                                                        <span className='row_count_value_d2'>
                                                            <div className="export_btn_hover_d2 d-flex align-items-center">
                                                                {/* <Button className="export_btn_d2">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                        <g clip-path="url(#clip0_8859_7240)">
                                                                            <path d="M13.333 9.77332V13.3333C13.333 13.6869 13.1925 14.0261 12.9425 14.2761C12.6924 14.5262 12.3533 14.6667 11.9997 14.6667H2.66634C2.31272 14.6667 1.97358 14.5262 1.72353 14.2761C1.47348 14.0261 1.33301 13.6869 1.33301 13.3333V3.99999C1.33301 3.64637 1.47348 3.30723 1.72353 3.05718C1.97358 2.80713 2.31272 2.66666 2.66634 2.66666H6.22634" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                            <path d="M11.9997 1.33334L14.6663 4.00001L7.99967 10.6667H5.33301V8.00001L11.9997 1.33334Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </g>
                                                                        <defs>
                                                                            <clipPath id="clip0_8859_7240">
                                                                                <rect width="16" height="16" fill="white" />
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>
                                                                    Edit
                                                                </Button> */}

                                                                <div className='primary_checkbox'>
                                                                    <Checkbox
                                                                        checked={blockAllChecked}
                                                                        onChange={handleBlockAll}
                                                                        disabled={!isEditMode}
                                                                    >
                                                                        <span className="form_label">Block all sensitive categories</span>
                                                                    </Checkbox>
                                                                </div>
                                                                {!isEditMode ?
                                                                    <Button className="export_btn_d2"
                                                                        style={{ padding: ' 0 2rem' }}
                                                                        onClick={() => { setIsEditMode(true); }}
                                                                    >
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                            <g clip-path="url(#clip0_8859_7240)">
                                                                                <path d="M13.333 9.77332V13.3333C13.333 13.6869 13.1925 14.0261 12.9425 14.2761C12.6924 14.5262 12.3533 14.6667 11.9997 14.6667H2.66634C2.31272 14.6667 1.97358 14.5262 1.72353 14.2761C1.47348 14.0261 1.33301 13.6869 1.33301 13.3333V3.99999C1.33301 3.64637 1.47348 3.30723 1.72353 3.05718C1.97358 2.80713 2.31272 2.66666 2.66634 2.66666H6.22634" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M11.9997 1.33334L14.6663 4.00001L7.99967 10.6667H5.33301V8.00001L11.9997 1.33334Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </g>
                                                                            <defs>
                                                                                <clipPath id="clip0_8859_7240">
                                                                                    <rect width="16" height="16" fill="white" />
                                                                                </clipPath>
                                                                            </defs>
                                                                        </svg>
                                                                        Edit
                                                                    </Button>
                                                                    :
                                                                    buttonValue ?
                                                                        <button className='btn btn_primary w_fit_content md mt-0'>
                                                                            <span>Processing...</span>
                                                                        </button>
                                                                        :
                                                                        <button className='btn btn_primary w_fit_content md mt-0'
                                                                            style={{ padding: '0 3rem' }}
                                                                            onClick={(e) => {
                                                                                // if (!isEditMode) {
                                                                                //     // EDIT clicked
                                                                                //     setIsEditMode(true);
                                                                                // } else {
                                                                                // SAVE clicked
                                                                                handleSubmit(e);
                                                                                // }
                                                                            }}
                                                                        >
                                                                            <span>Save</span>
                                                                        </button>

                                                                }


                                                            </div>
                                                        </span>
                                                    </div>

                                                </div>

                                                <div className="table-body-scroll without_hover_tr">
                                                    <table className="category-table --category_table_newspacing">
                                                        {/* <thead>
                                                            <tr>
                                                                <th className="cell checkbox-col" style={{ borderRight: "1px solid #EAECF0" }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        ref={masterRef}
                                                                        checked={allSelectedAll}
                                                                        onChange={handleMaster}
                                                                        aria-label="Select all"
                                                                    // disabled={isDisabled}

                                                                    />
                                                                </th>
                                                                <th className="name-col">Name</th>
                                                            </tr>
                                                        </thead> */}
                                                        <tbody className="scroll-body">
                                                            {DATA.length > 0 ? (

                                                                // DATA.map((node, index) => (
                                                                //   <CategoryRows
                                                                //     key={node.id}
                                                                //     node={node}
                                                                //     selected={selected}
                                                                //     setSelected={setSelected}
                                                                //     searchTerm={searchTerm}
                                                                //     defaultOpen={index === 0}
                                                                //   />
                                                                // ))

                                                                visibleNodes.length === 0 ? (
                                                                    <tr>
                                                                        <td colSpan={2} style={{ textAlign: "center", height: "20rem", width: "72rem" }}>
                                                                            <div className="no-data">No data found</div>
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    visibleNodes.map(node => (
                                                                        <CategoryRows
                                                                            key={node.id}
                                                                            node={node}
                                                                            selected={selected}
                                                                            setSelected={setSelected}
                                                                            searchTerm={searchTerm.toLowerCase()}
                                                                            isDisabled={!isEditMode}
                                                                            sensitive={sensitive}
                                                                            setSensitive={setSensitive}
                                                                            attemptedIds={sensitiveAttemptedIds}
                                                                            setSensitiveAttemptedIds={setSensitiveAttemptedIds}
                                                                        />
                                                                    ))
                                                                )



                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={2} style={{ textAlign: "center", height: "20rem", width: "72rem" }}>
                                                                        <div className="no-data">No data found</div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}

export default BrandSafety;
